import script from "./VBreadcrumbs.vue?vue&type=script&setup=true&lang=ts"
export * from "./VBreadcrumbs.vue?vue&type=script&setup=true&lang=ts"

import "./VBreadcrumbs.vue?vue&type=style&index=0&id=ec6ab36c&scoped=true&lang=postcss"

import exportComponent from "/builds/frontend/dsp/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ec6ab36c"]])

export default __exports__